import React, { Component } from 'react';
import Main from './Main';
import './css/App.css';

class App extends Component {
  render() {
    return (
      <div className="main">
        <Main />
      </div>
    );
  }
}

export default App;
